// extracted by mini-css-extract-plugin
module.exports = {"trailResult":"PageUITrailResult_trailResult__5MJq_"};